import {
  EngineMultiConfigAPIPromiseClient,
} from "../../../gen/witbooking/backoffice/enginemulticonfig/v1/engine_multi_config_api_grpc_web_pb";
import {
  CreateEngineMultiConfigRequest,
  DeleteEngineMultiConfigRequest,
  GetAllEngineMultiConfigRequest,
  EngineMultiConfig,
  UpdateEngineMultiConfigRequest,
  GetEngineMultiConfigRequest, GetEngineMultiConfigDefaultSerializeRequest, ValidateEngineMultiConfigSerializeRequest,
} from "../../../gen/witbooking/backoffice/enginemulticonfig/v1/engine_multi_config_api_pb";
import { buildGrpcClient } from "../../../lib/grpc";
import { EngineMultiConfigEntity } from "../domain/engineMultiConfig.entity";

function engineMultiConfigToGrpc(entity: EngineMultiConfigEntity): EngineMultiConfig {
  const configuration = new EngineMultiConfig();
  configuration.setId(entity.id);
  configuration.setTicker(entity.ticker);
  configuration.setTriggersList(entity.triggersList.map((it) => it.trim()));
  configuration.setSerialized(JSON.stringify(entity.serialized));
  return configuration;
}

const engineMultiConfigClient: EngineMultiConfigAPIPromiseClient = buildGrpcClient(
  EngineMultiConfigAPIPromiseClient,
);

export async function getAllEngineMultiConfigs(token: string): Promise<EngineMultiConfigEntity[]> {
  const request = new GetAllEngineMultiConfigRequest();
  const response = await engineMultiConfigClient.getAllEngineMultiConfig(request, {
    Authorization: `Bearer ${token}`,
  });
  return response.getConfigurationsList().map((it) => it.toObject());
}

export async function getOneEngineMultiConfig(id: string, token: string): Promise<EngineMultiConfigEntity> {
  const request = new GetEngineMultiConfigRequest();
  request.setId(id);
  const response = await engineMultiConfigClient.getEngineMultiConfig(request, {
    Authorization: `Bearer ${token}`,
  });
  const configuration = response.getConfiguration();
  if (!configuration) {
    throw new Error("Unexpected reply obtaining engineMultiConfig");
  }
  return configuration.toObject();
}

export async function createEngineMultiConfig(
  entity: EngineMultiConfigEntity,
  token: string,
): Promise<void> {
  const request = new CreateEngineMultiConfigRequest();
  const configuration = engineMultiConfigToGrpc(entity);
  request.setConfiguration(configuration);
  await engineMultiConfigClient.createEngineMultiConfig(request, {
    Authorization: `Bearer ${token}`,
  });
}

export async function updateEngineMultiConfig(
  entity: EngineMultiConfigEntity,
  token: string,
): Promise<void> {
  const request = new UpdateEngineMultiConfigRequest();
  const configuration = engineMultiConfigToGrpc(entity);
  request.setConfiguration(configuration);
  await engineMultiConfigClient.updateEngineMultiConfig(request, {
    Authorization: `Bearer ${token}`,
  });
}

export async function deleteEngineMultiConfig(id: string, token: string): Promise<void> {
  const request = new DeleteEngineMultiConfigRequest();
  request.setId(id);
  await engineMultiConfigClient.deleteEngineMultiConfig(request, {
    Authorization: `Bearer ${token}`,
  });
}

export async function getEngineV21AggregateSerializedData(token: string): Promise<string> {
  const request = new GetEngineMultiConfigDefaultSerializeRequest();
  const response = await engineMultiConfigClient.getEngineMultiConfigDefaultSerialize(request, {
    Authorization: `Bearer ${token}`,
  });
  return response.getSerialized();
}

export async function validateEngineV21AggregateSerializedData(token: string, serialized: string): Promise<void> {
  const request = new ValidateEngineMultiConfigSerializeRequest()
  request.setSerialized(serialized);
  await engineMultiConfigClient.validateEngineMultiConfigSerialize(request, {
    Authorization: `Bearer ${token}`,
  });
}
